module.exports = __webpack_public_path__ + "static/img/locationbg.00a8a43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/concatUs/locationbg.png
// module id = 0vv7
// module chunks = 1